export default {
  lines: {
    po: 50
  }
}
